<!--
  MODERN SIDEBAR - Angular 20 + Tailwind CSS
  Implementación dentro del layout full existente
-->

<!-- ========== HEADER CON LOGO Y TOGGLE ========== -->
<div class="flex items-center justify-between px-6 py-5 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 flex-shrink-0 min-h-[76px]">

  <!-- Logo y Título (expandido o mobile) -->
  <!-- Importante: NO navegar al hacer click en el branding; evita que 'Dashboard' quede seleccionado cuando el usuario solo quiere usar el header/selector -->
  <div *ngIf="!isCollapsed || isMobile" class="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer" role="presentation"
       (click)="router.navigate(['/dashboard/home'])">
    <!-- Logo/Icon -->
    <div class="flex-shrink-0 w-10 h-10 flex items-center justify-center">
      <img src="assets/images/logo_partnertech.png" alt="Logo PartnerTech" class="w-full h-full object-contain">
    </div>

    <!-- Título -->
    <div class="flex flex-col">
      <h1 class="text-base font-bold text-gray-900 dark:text-white">
        {{ 'sidebar.brand.title' | translate }}
      </h1>
      <p class="text-xs text-gray-500 dark:text-gray-400">
        {{ 'sidebar.brand.systemVersion' | translate }}
      </p>
    </div>
  </div>

  <!-- Logo centrado cuando está colapsado (solo desktop) -->
  <div *ngIf="isCollapsed && !isMobile" class="flex items-center justify-center w-full hover:opacity-80 transition-opacity cursor-pointer" role="presentation"
       (click)="router.navigate(['/dashboard/home'])">
    <div class="w-10 h-10 flex items-center justify-center">
      <img src="assets/images/logo_partnertech.png" alt="Logo PartnerTech" class="w-full h-full object-contain">
    </div>
  </div>
</div>

<!-- ========== NAVEGACIÓN (solo esta zona hace scroll; cabecera y pie quedan fijos) ========== -->
<nav class="sidebar-nav-scroll flex-1 min-h-0 overflow-y-auto overflow-x-hidden py-4 overscroll-contain">

  <ul class="space-y-1 list-none m-0 p-0" [ngClass]="isCollapsed && !isMobile ? 'px-2' : 'pl-6 pr-4'">
    <ng-container *ngFor="let item of menuItems; trackBy: trackByLabel">

      <!-- ========== SEPARADOR DE CATEGORÍA ========== -->
      <li *ngIf="item.navCap" class="mt-6 mb-3 list-none first:mt-2">
        <h3 [class]="
          'font-extrabold text-gray-500 dark:text-gray-400 uppercase tracking-widest truncate ' +
          (isCollapsed && !isMobile ? 'text-[9px] text-center' : 'text-[10px] pl-1')
        ">
          {{ isCollapsed && !isMobile ? '...' : (item.navCap | translate) }}
        </h3>
      </li>

      <li *ngIf="item.displayName && !item.children" [class]="'list-none ' + (isCollapsed && !isMobile ? 'mb-4' : 'mb-2')">
        <a [routerLink]="item.route"
           *hasRole="item.roles || []"
           [class]="
             'flex items-center rounded-lg transition-colors duration-200 group relative overflow-hidden ' +
             (isRouteActive(item.route)
               ? 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 font-semibold before:absolute before:inset-y-0 before:left-0 before:w-1 before:bg-emerald-600 dark:before:bg-emerald-500 before:rounded-r-full'
               : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-emerald-600 dark:hover:text-emerald-400'
             ) +
             (isCollapsed && !isMobile ? ' justify-center h-12 w-12 mx-auto' : ' gap-3 pl-4 pr-3 py-2.5')
           ">

           <!-- Icono -->
          <span class="flex-shrink-0 flex items-center justify-center transition-opacity duration-200" [class]="isCollapsed && !isMobile ? '' : 'opacity-70'">
            <i class="iconify text-[22px]" [attr.data-icon]="item.iconName"></i>
          </span>

          <!-- Texto del label -->
          <span *ngIf="!isCollapsed || isMobile"
                class="sidebar-menu-label flex-1 text-[14px] font-normal">
            {{ item.displayName | translate }}
          </span>

          <!-- Badge/Chip estilo "New" -->
          <span *ngIf="item.chip && (!isCollapsed || isMobile)"
                [class]="'ml-auto px-2 py-0.5 text-[10px] font-bold rounded-md ' + (item.chipClass || 'bg-emerald-500 text-white')">
            {{ item.chipContent }}
          </span>

          <!-- Tooltip para modo colapsado -->
          <div *ngIf="isCollapsed && !isMobile"
               class="absolute left-full ml-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 pointer-events-none shadow-xl">
            {{ item.displayName | translate }}
            <div class="absolute top-1/2 -left-1 -translate-y-1/2 w-2 h-2 bg-gray-900 dark:bg-gray-700 rotate-45"></div>
          </div>
        </a>
      </li>

      <!-- ========== ITEM CON HIJOS (Accordion) ========== -->
      <li *ngIf="item.displayName && item.children" [class]="'list-none ' + (isCollapsed && !isMobile ? 'mb-4' : 'mb-2')">

        <!-- Botón del padre -->
        <button
          (click)="toggleSubmenu(item)"
          [class]="
            'w-full flex items-center rounded-lg transition-colors duration-200 group relative overflow-hidden ' +
            (hasActiveChild(item)
              ? 'bg-emerald-500 dark:bg-emerald-600 text-white font-semibold'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-emerald-600 dark:hover:text-emerald-400'
            ) +
            (isCollapsed && !isMobile ? ' justify-center h-12 w-12 mx-auto' : ' gap-3 pl-4 pr-3 py-2.5')
          "
          type="button">

          <!-- Icono del padre -->
          <span class="flex-shrink-0 flex items-center justify-center transition-opacity duration-200" [class]="isCollapsed && !isMobile ? '' : 'opacity-70'">
            <i class="iconify text-[22px]" [attr.data-icon]="item.iconName"></i>
          </span>

          <!-- Texto del label -->
          <span *ngIf="!isCollapsed || isMobile"
                class="sidebar-menu-label flex-1 text-left text-[14px] font-normal">
            {{ item.displayName | translate }}
          </span>

          <!-- Badge/Chip estilo "New" -->
          <span *ngIf="item.chip && (!isCollapsed || isMobile) && !item.children"
                [class]="'px-2 py-0.5 text-[10px] font-bold rounded-md ' + (item.chipClass || 'bg-emerald-500 text-white')">
            {{ item.chipContent }}
          </span>

          <!-- Chevron -->
          <svg *ngIf="(!isCollapsed || isMobile) && item.children"
               class="w-4 h-4 transition-transform duration-200"
               [class.rotate-180]="item.isExpanded"
               [class.opacity-70]="!hasActiveChild(item)"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>

          <!-- Tooltip para modo colapsado -->
          <div *ngIf="isCollapsed && !isMobile"
               class="absolute left-full ml-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 pointer-events-none shadow-xl">
            {{ item.displayName | translate }}
            <div class="absolute top-1/2 -left-1 -translate-y-1/2 w-2 h-2 bg-gray-900 dark:bg-gray-700 rotate-45"></div>
          </div>
        </button>

        <!-- Submenú (accordion) -->
        <ul *ngIf="item.isExpanded && (!isCollapsed || isMobile)"
            class="sidebar-submenu-list mt-1 pr-1 space-y-0.5 overflow-hidden"
            [@slideDown]>

          <ng-container *ngFor="let child of item.children; trackBy: trackByLabel">
          <li *ngIf="!child.hidden"
              class="sidebar-submenu-item">
            <a [routerLink]="child.route"
               *hasRole="child.roles || []"
               [class]="
                 'sidebar-submenu-link relative flex items-center gap-2.5 rounded-lg transition-all duration-150 group ' +
                 (isRouteActive(child.route)
                   ? 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 font-medium before:absolute before:left-0 before:inset-y-1 before:w-[3px] before:bg-emerald-600 dark:before:bg-emerald-400 before:rounded-r-full'
                   : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800/60 hover:text-emerald-600 dark:hover:text-emerald-400'
                 )
               ">

              <!-- Icono del subitem (Circulito vacio/lleno) -->
              <span class="sidebar-submenu-dot flex items-center justify-center flex-shrink-0">
                <span class="w-[6px] h-[6px] rounded-full border-[1.5px] border-current transition-all duration-200"
                      [ngClass]="isRouteActive(child.route) ? 'bg-emerald-600 border-emerald-600 dark:bg-emerald-400 dark:border-emerald-400 scale-125' : 'bg-transparent opacity-50 group-hover:opacity-100 group-hover:border-emerald-600 dark:group-hover:border-emerald-400'"></span>
              </span>

              <!-- Texto del subitem -->
              <span class="sidebar-submenu-title text-[13.5px]">{{ child.displayName | translate }}</span>

              <!-- Badge en sub-item -->
              <span *ngIf="child.chip"
                    [class]="'ml-auto px-2 py-0.5 text-[10px] font-bold rounded-md ' + (child.chipClass || 'bg-emerald-500 text-white')">
                {{ child.chipContent }}
              </span>
            </a>
          </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
  </nav>

<!-- ========== FOOTER: PERFIL DE USUARIO ========== -->
<div class="flex-shrink-0 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
     [ngClass]="isCollapsed && !isMobile ? 'py-5 px-3' : 'p-3'">

  <!-- MODO EXPANDIDO -->
  <div *ngIf="!isCollapsed || isMobile"
       role="button"
       tabindex="0"
       (click)="goMiPerfil($event)"
       (keydown.enter)="goMiPerfil($event)"
       [attr.title]="showMiPerfil() ? ('Ir a mi perfil' | translate) : ''"
       [attr.aria-disabled]="!showMiPerfil()"
       [class.opacity-60]="!showMiPerfil()"
       [class.pointer-events-none]="!showMiPerfil()"
       class="flex items-center gap-3 p-2.5 rounded-xl bg-gray-50 dark:bg-gray-800 border border-gray-100 dark:border-gray-700 hover:border-emerald-200 dark:hover:border-emerald-700 hover:bg-emerald-50/30 dark:hover:bg-emerald-900/10 transition-all duration-200 cursor-pointer group">

    <!-- Avatar -->
    <div class="relative flex-shrink-0">
      <img src="assets/images/profile/user-1.jpg"
           alt="Avatar"
           class="w-9 h-9 rounded-full object-cover ring-2 ring-white dark:ring-gray-700 shadow-sm group-hover:ring-emerald-200 dark:group-hover:ring-emerald-700 transition-all duration-200">
      <!-- Punto de estado online -->
      <span class="absolute bottom-0 right-0 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-white dark:border-gray-800"></span>
    </div>

    <!-- Nombre y rol -->
    <div class="flex-1 min-w-0">
      <p class="text-[13px] font-semibold text-gray-800 dark:text-gray-100 truncate leading-tight">{{ displayName }}</p>
      <p class="text-[11px] text-gray-500 dark:text-gray-400 truncate leading-tight mt-0.5">{{ displayRole }}</p>
    </div>

    <!-- Indicador visual (tres puntos) -->
    <div class="flex-shrink-0 flex flex-col gap-[3px] opacity-40 group-hover:opacity-80 transition-opacity duration-200">
      <span class="w-1 h-1 rounded-full bg-gray-500 dark:bg-gray-400"></span>
      <span class="w-1 h-1 rounded-full bg-gray-500 dark:bg-gray-400"></span>
      <span class="w-1 h-1 rounded-full bg-gray-500 dark:bg-gray-400"></span>
    </div>
  </div>

  <!-- MODO COLAPSADO: solo avatar centrado -->
  <div *ngIf="isCollapsed && !isMobile"
       class="flex justify-center items-center">
    <div class="relative"
         role="button"
         tabindex="0"
         (click)="goMiPerfil($event)"
         (keydown.enter)="goMiPerfil($event)"
         [attr.title]="showMiPerfil() ? ('Ir a mi perfil' | translate) : ''"
         [attr.aria-disabled]="!showMiPerfil()"
         [class.opacity-60]="!showMiPerfil()"
         [class.pointer-events-none]="!showMiPerfil()">
      <img src="assets/images/profile/user-1.jpg"
           alt="Avatar"
           class="w-9 h-9 rounded-full object-cover ring-2 ring-white dark:ring-gray-700 shadow-sm hover:ring-emerald-300 transition-all duration-200 cursor-pointer">
      <!-- Punto de estado online -->
      <span class="absolute bottom-0 right-0 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-white dark:border-gray-800"></span>
    </div>
  </div>
</div>
